import { useState } from 'react';
import { useMachine } from '../../state/machine.ts';
import { useSession } from '../../state/session.store.ts';
import { useUi } from '../../state/ui.store.ts';
import { apiAuth } from '../../services/api.ts';
import { env } from '../../env.ts';
import s from './LegalGate.module.css';

export function LegalGate() {
  const send = useMachine((m) => m.send);
  const session = useSession();
  const pushToast = useUi((u) => u.pushToast);
  const [age, setAge] = useState(false);
  const [bio, setBio] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const ready = age && bio;

  const onSubmit = async () => {
    if (!ready || submitting) return;
    setSubmitting(true);
    try {
      // If session already exists, record consent server-side. Otherwise the
      // calibration step will record it after PoW completes — set local flag.
      session.set({ consentRecorded: true });
      if (session.token) {
        await apiAuth.consent(
          { biometricConsent: true, ageConfirm: true, tosVersion: env.tosVersion },
          session.token,
        );
      }
      send('CONSENT_OK');
    } catch (err) {
      pushToast({
        kind: 'error',
        ttlMs: 4000,
        message: err instanceof Error ? err.message : 'consent submission failed',
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className={s.root}>
      <div className={s.card}>
        <button type="button" className={s.back} onClick={() => send('BACK_TO_LANDING')}>
          ← back
        </button>
        <h2 className={s.title}>before you enter</h2>
        <p className={s.body}>
          Auramegle uses your camera and runs facial-landmark inference on your
          device to score the duel. We never save your video unless you report
          your opponent. Auto-clips include only your own face — never theirs.
        </p>

        <label className={s.row}>
          <input
            type="checkbox"
            checked={age}
            onChange={(e) => setAge(e.target.checked)}
            aria-label="confirm 18 or older"
          />
          <span>I am 18 or older.</span>
        </label>

        <label className={s.row}>
          <input
            type="checkbox"
            checked={bio}
            onChange={(e) => setBio(e.target.checked)}
            aria-label="biometric processing consent"
          />
          <span>
            I consent to local biometric processing of my face for scoring,
            and to the Terms of Service.
          </span>
        </label>

        <button
          type="button"
          className={s.cta}
          disabled={!ready || submitting}
          onClick={onSubmit}
        >
          {submitting ? 'recording consent…' : 'continue'}
        </button>
      </div>
    </main>
  );
}
